import { Box, Typography } from "@mui/material";
import { memo } from "react";

import { ProductIconTile } from "@/components/Atoms";
import { formatPersianCurrency, formatPersianNumber } from "@/lib/format/persian";
import type { QuickOrderLineItemProps } from "./QuickOrderLineItem.types";
import * as styles from "./QuickOrderLineItem.styles";

export type { QuickOrderLineItemProps } from "./QuickOrderLineItem.types";

export const QuickOrderLineItem = memo(function QuickOrderLineItem({ item }: QuickOrderLineItemProps) {
  return (
    <Box sx={styles.root}>
      <ProductIconTile imageUrl={item.product.image_url} alt={item.product.name} />
      <Box sx={styles.details}>
        <Typography sx={styles.name}>{item.product.name}</Typography>
        <Typography sx={styles.price}>{formatPersianCurrency(item.product.price)}</Typography>
      </Box>
      <Typography sx={styles.quantity}>×{formatPersianNumber(item.quantity)}</Typography>
    </Box>
  );
});
